export const regionalLanguage = [
  {
    id: 'tamil',
    title: 'Tamil',
    language: 'தமிழ்',
    img: '/Assets/navIcons/regionalsIcon/Tamil.svg',
    whiteImg: '/Assets/navIcons/regionalsIconWhite/TamilWhite.svg',
  },
  {
    id: 'telugu',
    title: 'Telugu',
    language: 'తెలుగు',
    img: '/Assets/navIcons/regionalsIcon/Telugu.svg',
    whiteImg: '/Assets/navIcons/regionalsIconWhite/TeluguWhite.svg',
  },
  {
    id: 'hindi',
    title: 'Hindi',
    language: 'हिन्दी',
    img: '/Assets/navIcons/regionalsIcon/Hindi.svg',
    whiteImg: '/Assets/navIcons/regionalsIconWhite/HindiWhite.svg',
  },
  {
    id: 'kannada',
    title: 'Kannada',
    language: 'ಕನ್ನಡ',
    img: '/Assets/navIcons/regionalsIcon/Kannada.svg',
    whiteImg: '/Assets/navIcons/regionalsIconWhite/KannadaWhite.svg',
  },
  {
    id: 'bengali',
    title: 'Bengali',
    language: 'বাংলা',
    img: '/Assets/navIcons/regionalsIcon/Bengali.svg',
    whiteImg: '/Assets/navIcons/regionalsIconWhite/BengaliWhite.svg',
  },
];
